import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import Limitpage from "./limitpage";
import Limitsetting from "./limitsetting";
import ServiceManage from "./serviceManage";

const App = ({ match }) => {
  return (
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/main`} />
      <Route path={`${match.url}/main`} component={Limitpage} />
      <Route path={`${match.url}/manage/:service`} component={ServiceManage} />
      <Route
        path={`${match.url}/setting/:id/:service`}
        component={Limitsetting}
      />
      <Redirect to="/error" />
    </Switch>
  );
};

export default App;
